<template>
    <div class="DshMenuNav">
        <!-- 坑 -->
        <div v-if="position === 'right'" class="DshMenuNav-view">
            <router-view></router-view>
        </div>

        <div
            v-if="showMenuList"
            :class="['DshMenuNav-nav', `DshMenuNav-nav-${position}`, `DshMenuNav-nav-${layout}`]"
            :style="{ width: `${+width}px` }"
        >
            <div v-if="title" class="DshMenuNav-nav-title">
                <!-- <Icon type="ios-settings" size="18" /> -->
                <span>{{ title }}</span>
            </div>

            <div class="list" :style="{ marginBottom: routeList.some(routeItem => routeItem.meta.bottom) ? '60px' : undefined }">
                <div
                    v-for="routeItem in routeList"
                    :key="routeItem.name"
                    :class="['list-item', { 'list-item-active': routeItem.name === $getRouteName() }, { 'list-item-bottom': routeItem.meta.bottom } ]"
                    :style="{ fontWeight: routeItem.meta.weight ? 600 : undefined }"
                    @click="$goPage(routeItem)"
                >
                    <span
                        v-if="routeItem.meta.beforeText"
                        class="list-item-beforeText"
                        @click.stop="0"
                    >{{ routeItem.meta.beforeText }}</span>
                    <Icon
                        class="list-item-iconClass"
                        v-if="routeItem.meta.icon"
                        :custom="'bico-font ' + routeItem.meta.icon"
                    />
                    <span style="vertical-align:middle;">{{ routeItem.meta.title }}</span>
                </div>
            </div>
        </div>

        <!-- 坑 -->
        <div v-if="position === 'left'" class="DshMenuNav-view">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DshMenuNav",
        props: {
            position: {
                type: String,
                default: "left"
            },
            width: {
                type: [String, Number],
                default: "200"
            },
            title: String,
            routeList: {
                type: Array,
                default () {
                    return [];
                }
            },
            showMenuList: {
                type: Boolean,
                default: true
            },
            layout: String
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/menu/DshMenuNav.vue